import * as React from "react";
import { SVGProps } from "react";
const Account = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 18C17.5172 18.6585 16.4138 19.5 15 19.5C13.5862 19.5 12.5172 18.6951 12 18"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M13 12V13.5"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M17 12V13.5"
      stroke="currentColor"
      strokeWidth={2}
      strokeMiterlimit={10}
      strokeLinecap="round"
    />
    <path
      d="M25.7442 12.6883L24.7673 12.9018C24.8293 13.1854 25.0114 13.428 25.2663 13.5667C25.5212 13.7054 25.8238 13.7265 26.0956 13.6245L25.7442 12.6883ZM25.7424 17.3118L25.9851 16.3417C25.7218 16.2758 25.443 16.3198 25.2128 16.4635C24.9825 16.6073 24.8206 16.8385 24.7642 17.104L25.7424 17.3118ZM14.9828 25C14.4305 25 13.9828 25.4478 13.9828 26C13.9828 26.5523 14.4305 27 14.9828 27V25ZM4.2574 12.6888L3.90606 13.625C4.17778 13.727 4.48039 13.7059 4.73532 13.5672C4.99026 13.4285 5.17235 13.1858 5.23433 12.9023L4.2574 12.6888ZM4.2574 17.3118L5.23559 17.104C5.17871 16.8362 5.01448 16.6034 4.78122 16.4599C4.54796 16.3165 4.26608 16.275 4.00138 16.3451L4.2574 17.3118ZM15.017 27C15.5693 27 16.017 26.5523 16.017 26C16.017 25.4478 15.5693 25 15.017 25V27ZM4.25579 17.3122L4.49851 18.2824L4.51181 18.2789L4.25579 17.3122ZM15.0134 5C19.7976 5 23.7787 8.37937 24.7673 12.9018L26.7211 12.4747C25.5392 7.06775 20.7718 3 15.0134 3V5ZM24.7642 17.104C23.8062 21.6156 19.804 25 14.9828 25V27C20.7662 27 25.5701 22.9374 26.7206 17.5195L24.7642 17.104ZM26.0956 13.6245C26.2541 13.565 26.4135 13.5336 26.5504 13.5336V11.5336C26.1291 11.5336 25.7304 11.6254 25.3929 11.752L26.0956 13.6245ZM26.5504 13.5336C27.339 13.5336 28 14.1795 28 14.985H30C30 13.0598 28.4284 11.5336 26.5504 11.5336V13.5336ZM28 14.985C28 15.7987 27.3618 16.4363 26.5504 16.4363V18.4363C28.4677 18.4363 30 16.9019 30 14.985H28ZM26.5504 16.4363C26.4047 16.4363 26.2277 16.4023 25.9851 16.3417L25.4997 18.2819C25.7533 18.3453 26.138 18.4363 26.5504 18.4363V16.4363ZM15.017 3C9.26175 3 4.46308 7.06512 3.28047 12.4752L5.23433 12.9023C6.22224 8.38293 10.2297 5 15.017 5V3ZM3.27921 17.5195C4.4297 22.9374 9.23361 27 15.017 27V25C10.1958 25 6.19361 21.6156 5.23559 17.104L3.27921 17.5195ZM4.60874 11.7525C4.27156 11.626 3.87117 11.5336 3.44959 11.5336V13.5336C3.58615 13.5336 3.74712 13.5654 3.90606 13.625L4.60874 11.7525ZM3.44959 11.5336C1.57156 11.5336 0 13.0598 0 14.985H2C2 14.1795 2.66098 13.5336 3.44959 13.5336V11.5336ZM0 14.985C0 16.9019 1.5323 18.4363 3.44959 18.4363V16.4363C2.63822 16.4363 2 15.7987 2 14.985H0ZM3.44959 18.4363C3.86182 18.4363 4.24455 18.3458 4.49848 18.2823L4.01309 16.3421C3.77091 16.4027 3.5955 16.4363 3.44959 16.4363V18.4363ZM15.0134 5H15.017V3H15.0134V5ZM4.00138 16.3451L3.99977 16.3455L4.51181 18.2789L4.51342 18.2784L4.00138 16.3451Z"
      fill="currentColor"
    />
  </svg>
);
export default Account;
